export const useClientStatic = defineStore('repo.client.static', () => {
    const sizes = ref([
        { id: 't', color: '#ff9800', extended: false },
        { id: 'xs', color: '#f44336', extended: false },
        { id: 's', color: '#2196f3', extended: false },
        { id: 'm', color: '#ad1457', extended: false },
        { id: 'l', color: '#7cb342', extended: false },
        { id: 'xl', color: '#3f51b5', extended: false },
        { id: 'xl+', color: '#3f51b5', extended: true },
        { id: 'xxl', color: '#212121', extended: true },
    ]);

    //https://skr.se/download/18.427140af179361c4e462c7c8/1620639375793/SFTI%20Shortlist_UnitsOfMeasureCodes_20191017.pdf
    const commonCode = ref({
        kg: 'KGM',
        hg: 'HGM',
        g: 'GRM',
        mg: 'MGM'
    });

    const availability = ref({
        is: 'https://schema.org/InStock',
        os: 'https://schema.org/OutOfStock',
        sp: 'Supplier', // ????
        bo: 'https://schema.org/BackOrder',
        boo: 'https://schema.org/BackOrder',
        ns: 'https://schema.org/LimitedAvailability', // ????
    });
    
    return {
        sizes,
        commonCode,
        availability
    };
})